import * as awsService from './awsDomainService';
import * as mailgunService from './mailgunDomainService';

// Create service objects that match the expected interface
export const awsDomainService = {
  getDomains: awsService.getDomains,
  getDomain: awsService.getDomain,
  createDomain: awsService.createDomain,
  verifyDomain: awsService.verifyDomain,
  deleteDomain: awsService.deleteDomain,
};

export const mailgunDomainService = {
  getDomains: mailgunService.getDomains,
  getDomain: mailgunService.getDomain,
  createDomain: mailgunService.createDomain,
  verifyDomain: mailgunService.verifyDomain,
  deleteDomain: mailgunService.deleteDomain,
};

// Factory function to get the appropriate service based on provider type
export const getDomainService = (provider: 'aws' | 'mailgun') => {
  switch (provider) {
    case 'aws':
      return awsDomainService;
    case 'mailgun':
      return mailgunDomainService;
    default:
      throw new Error(`Unsupported provider: ${provider}`);
  }
};
